import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import appSelectors from 'redux/app/appSelectors';
import authSelectors from 'redux/auth/authSelectors';

import useMatchMedia from 'hooks/useMatchMedia';

import Container from 'components/container';
import Logo from 'components/logo';

import Balance from './balance';
import BtnLang from './btnLang';
import BtnTheme from './btnTheme';
import BtnProfile from './btnProfile';
import BtnMenu from './btnMenu';
import Menu from './menu';
import MenuMonitoringPublic from './menuMobitoringPublic';
import Nav from './nav';
import NavMonitoringPublic from './navMonitoringPublic';

import s from './header.module.css';

function Header() {
  const isAuth = useSelector(authSelectors.isAuthorized);
  const displayMenu = useSelector(appSelectors.displayMenu);

  const { pathname } = useLocation();

  const { isMobile, isDesktop } = useMatchMedia();

  return (
    <header className={s.section}>
      <Container>
        <div className={s.wrapper}>
          <Logo />

          {isAuth && isDesktop && <Nav />}
          {!isAuth && isDesktop && pathname.includes('online-monitoring') && (
            <NavMonitoringPublic />
          )}

          <div className={s.btns_wrapper}>
            <div>
              {isAuth && <Balance />}
              {(!isAuth || !isMobile) && <BtnTheme />}
              {(!isAuth || !isMobile) && <BtnLang />}
              {isAuth && <BtnProfile />}
            </div>

            {isAuth && !isDesktop && <BtnMenu />}
            {!isAuth &&
              !isDesktop &&
              pathname.includes('online-monitoring') && <BtnMenu />}
          </div>

          {isAuth && !isDesktop && displayMenu && <Menu />}
          {!isAuth &&
            !isDesktop &&
            displayMenu &&
            pathname.includes('online-monitoring') && <MenuMonitoringPublic />}
        </div>
      </Container>
    </header>
  );
}

export default Header;
